<div class="px-gutter py-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
  <details-skeleton-line-base *ngFor="let count of [].constructor(counts)"></details-skeleton-line-base>
</div>
